module.exports = __webpack_public_path__ + "static/img/aboutBg2.9226060.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/aboutBg2.jpg
// module id = 55ZN
// module chunks = 1